// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1WcGp","inner":"Form_inner__2irxj","range":"Form_range__1FOvx","name":"Form_name__1pYzy","actions":"Form_actions__15o_6"};